<template>
  <v-container>
    <v-btn
      color="green"
      dark
      outlined
      id="folder_create__nueva_carpeta__button"
      @click="dialogFolderCreate = true"
    >
      <v-icon small left>{{ icon.plus }}</v-icon>
      Nueva carpeta
    </v-btn>
    <v-dialog v-model="dialogFolderCreate" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <v-col cols="11">
            <span class="headline">Crear Carpeta</span>
          </v-col>
          <v-col cols="1" class="text-right">
            <v-btn
              id="folder_create__cerrar_ventana__button"
              name="folder_create__cerrar_ventana__button"
              icon
              @click="closeMe"
            >
              <v-icon>{{ icon.close }}</v-icon>
            </v-btn>
          </v-col>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="1" class="text-right pr-1">
              <v-icon color="orange lighten-3">
                {{ icon.folder }}
              </v-icon>
            </v-col>
            <v-col cols="11" class="text-left h6 pl-0">
              <v-alert dense border="top" type="warning" v-if="folder == null">
                {{ messageFolderUnselected }}
              </v-alert>
              <v-slide-group show-arrows v-if="folder != null">
                <v-slide-item
                  v-for="item in folder.ruta.length > 0 ? folder.ruta : []"
                  :key="item"
                >
                  <p>{{ '/' + item }}</p>
                </v-slide-item>
              </v-slide-group>
            </v-col>
          </v-row>
          <folder-form
            :parent="folder"
            @onSuccessActionFolder="successActionFolder"
            ref="folderForm"
          >
          </folder-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mdiClose, mdiFolderOutline, mdiPlus } from '@mdi/js'
import { panelData, panelActions, appThemeData } from '@/store/helpers'

import {
  folderStoreActions,
  folderStoreData
} from '../store/folderStoreHelpers'

import FolderForm from '@/modules/catalogs/components/FolderForm'

export default {
  name: 'FolderCreate',
  props: {
    folder: {
      type: Object,
      default: null
    }
  },
  components: {
    FolderForm
  },
  data() {
    return {
      icon: {
        close: mdiClose,
        folder: mdiFolderOutline,
        plus: mdiPlus
      },
      dialogFolderCreate: false
    }
  },
  computed: {
    ...panelData,
    ...appThemeData,
    ...folderStoreData
  },
  methods: {
    ...panelActions,
    ...folderStoreActions,
    closeMe() {
      this.dialogFolderCreate = false
      this.$refs.folderForm.resetForm()
    },
    createdFolder() {
      this.$emit('onCreateFolder')
      this.dialogFolderCreate = false
    },
    successActionFolder() {
      this.closeMe()
      this.getFolders()
    }
  }
}
</script>
